import axios from "./AxiosInstance"

const getDEConclusion = (patientId) => axios.get(`api/conclusions?paginated=false&patientId=${patientId}`)
const getPatientConclusion = (patientId) => axios.get(`api/conclusionsTemp?paginated=false&patientId=${patientId}`)
const acceptDEConclusion = ({ conclusionId }) => axios.put(`api/conclusionsTemp/${conclusionId}`, { isAccepted: 1 })
const denyDEConclusion = ({ conclusionId }) => axios.put(`api/conclusionsTemp/${conclusionId}`, { isAccepted: 0 })
const getConstantVitalSignsList = (userId) =>
    axios.get(`api/users/${userId}/constantVitalSigns?paginated=false&archived=0`)

export const ConclusionService = {
    getConstantVitalSignsList,
    getPatientConclusion,
    getDEConclusion,
    acceptDEConclusion,
    denyDEConclusion
}
